import React, { useMemo } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildLinkedIdentities } from './linkedIdentitiesModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function LinkedIdentities({ imposters, owner, showSummary = true }) {
    const model = useMemo(() => buildLinkedIdentities(imposters, owner), [imposters, owner])
    const { summary, rows } = model

    if (!rows.length) return <div className={styles.calmLine}>No other names or birth dates linked to the owner's SSN.</div>

    const warn = summary.invalid + summary.deceased
    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    <Badge tone={warn ? 'declined' : summary.usesOwners ? 'watch' : 'neutral'} dot={warn > 0}>
                        {plural(summary.count, 'other identity', 'other identities')}
                    </Badge>
                    {summary.usesOwners > 0 && <Badge tone='watch'>{summary.usesOwners} {summary.usesOwners === 1 ? "uses" : 'use'} the owner's SSN</Badge>}
                    {summary.invalid > 0 && <Badge tone='declined'>{plural(summary.invalid, 'SSN')} not valid</Badge>}
                    {summary.deceased > 0 && <Badge tone='declined'>{summary.deceased} deceased</Badge>}
                </div>
            )}
            <div className={styles.note}>
                Other names and birth dates Lexis has seen with this SSN. Usually a typo, a relative or an old record. Check the ones marked in red.
            </div>
            <RecordList items={rows} />
        </div>
    )
}
